import { z } from 'zod'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }

  return { message: ctx.defaultError }
})

export const sendCodeSchema = z.object({
  email: z.string().email('Email inválido')
})

export type sendCodeForm = z.infer<typeof sendCodeSchema>
